import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { FilterQuery } from '../../repository/types'
import type { Order } from '../Order'
import type { OrderItem } from '../OrderItem'

export interface IUpdateOrderItems extends IAction<Order, UpdateOrderItemsArgs> {}

/**
 * Args for the updateOrder_items path. Mirrors BaseChildResolver's contract (an arbitrary partial
 * item `input` plus a `filter` naming the order and the item); the resolver keeps its explicit JSON
 * `input`/`filter` args.
 */
@InputType()
export class UpdateOrderItemsArgs extends ActionArgs {
  /** The fields to change on the order item. */
  @Field(() => GraphQLJSON, { nullable: false })
  input: Partial<OrderItem>

  /** Names the order (`_id`) and the item (`items._id`). */
  @Field(() => GraphQLJSON, { nullable: false })
  filter: FilterQuery<Order>
}
